import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import {
  deSelectAllUsers,
  fetchClientUsers,
  reStateFilters,
  setClientUsersLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
} from "@/reducers/client_user/clientUsers";

import DropDownFilter from "../../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../../ListingFilters/FilterModalTop";
import TextFieldFilter from "../../ListingFilters/TextFieldFilter";

const FilterModal = () => {
  const { oldFilters, filters, showFilters, pagination } = useSelector(
    (state) => state.clientUsers,
  );

  const { roles } = useSelector((state) => state.userAccess);
  const dispatch = useDispatch();
  const { filterLists } = useSelector((state) => state.clientsCandidates);

  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showFilterModal(false));
  };

  // useEffect(() => {
  //   dispatch(fetchFiltersData());
  // }, []);

  const handleApply = () => {
    dispatch(setClientUsersLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllUsers());
    dispatch(fetchClientUsers(filters));
    handleClose();
  };

  const handleReset = () => {
    dispatch(updateFilters({}));
    dispatch(setClientUsersLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllUsers());
    dispatch(
      fetchClientUsers({
        search: filters.search,
      }),
    );
    handleClose();
  };

  return (
    <ModalPopUp
      show={showFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose();
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[18px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ userFirstName: value }));
              }}
              label="First name"
              value={filters.userFirstName}
              filterId="userFirstName"
              placeholder="Enter First name"
            />

            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ userLastName: value }));
              }}
              label="Last name"
              value={filters.userLastName}
              filterId="userLastName"
              placeholder="Enter Last name"
            />

            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ userEmail: value }));
              }}
              label="Email address"
              value={filters.userEmail}
              filterId="userEmail"
              placeholder="Enter Email adress"
            />

            <DropDownFilter
              options={
                roles && roles.length > 0
                  ? roles.map((role) => ({
                      value: role.id,
                      name: role?.role_name,
                    }))
                  : []
              }
              id="userRole"
              label="Role"
              placeholder="Select Role"
              value={filters.userRole}
              handleChange={(value) => {
                dispatch(updateFilters({ userRole: value }));
              }}
            />

            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ userPhoneNo: value }));
              }}
              label="Phone number"
              value={filters.userPhoneNo}
              filterId="userPhoneNo"
              placeholder="Enter Phone Number"
            />

            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ userDirectdial: value }));
              }}
              label="Direct Dial"
              value={filters.userDirectdial}
              filterId="userDirectdial"
              placeholder="Enter Direct Dial"
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};

export default FilterModal;
